export default __webpack_public_path__ + "static/media/day1_go.cfea4cad.jpg";